exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".featuredOps--container--2y3WLW-Q {\r\n  margin: 0 auto;\r\n  width: 96%;\r\n}\r\n\r\n.featuredOps--featureTitle--1fAI4DOc {\r\n  padding-left: 18px;\r\n  color: #5B6770;\r\n}\r\n\r\n.featuredOps--grid--e3iCIueM {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/opportunity/featuredOps/featuredOps.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;CACZ;;AAED;EACE,mBAAmB;EACnB,eAAe;CAChB;;AAED;EACE,kBAAkB;EAClB,mBAAmB;CACpB","file":"featuredOps.css","sourcesContent":[".container {\r\n  margin: 0 auto;\r\n  width: 96%;\r\n}\r\n\r\n.featureTitle {\r\n  padding-left: 18px;\r\n  color: #5B6770;\r\n}\r\n\r\n.grid {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "featuredOps--container--2y3WLW-Q",
	"featureTitle": "featuredOps--featureTitle--1fAI4DOc",
	"grid": "featuredOps--grid--e3iCIueM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/opportunity/featuredOps/featuredOps.css
// module id = 390
// module chunks = 0